import { useSyncExternalStore } from "react";
import { useT } from "~/i18n";
import { verificationStore } from "~/lib/api/commit-verification";

/**
 * Shown while a write whose answer was lost (gateway deadline) is being
 * re-checked with its idempotency key. The person sees progress, not an error,
 * and is told nothing is being duplicated.
 */
export function CommitVerifyingBanner() {
  const t = useT();
  const verifying = useSyncExternalStore(
    verificationStore.subscribe,
    verificationStore.getSnapshot,
    () => 0,
  );
  if (verifying === 0) return null;
  return (
    <output className="notice commit-verifying mb-0" data-tone="caution" aria-live="polite">
      <span aria-hidden="true">⏳</span>
      <span>
        <strong>{t("failure.verifying")}</strong> {t("failure.verifyingBody")}
      </span>
    </output>
  );
}
